/* nr-snabbval.js — snabb variantväljare på produktkorten (pilot 2026-09-15)
   ------------------------------------------------------------------
   Laddas med defer från layout/theme.liquid.
   Kombinationstemat 2026-09-26: köpet går via window.nrKombiLaggTill
   (assets/nr-kombi.js) till nya temats varukorgslåda.
   Kort med flera varianter har en länk [data-nr-snabbval="handle"] som
   pekar på produktsidan. Här fångas klicket och ett bottenark öppnas
   (dialog på desktop) med produktens riktiga varianter från
   /products/<handle>.js: alternativ som knappar, pris, jämförpris,
   lager/tillgänglighet och bild per variant. "Lägg i varukorgen" postar
   exakt variant-ID till /cart/add.js via jQuery så att Debutifys
   varukorgslåda och sidhuvudets räknare uppdateras som vid vanligt köp.

   Ordning på alternativen: färg/modell först, storlek sist, övriga
   emellan — samma regel som produktsidan (sections/nr-product.liquid).

   Tre lägen per värde, givet övriga val:
   — finns och i lager: vanlig knapp
   — finns men slutsåld: överstruken (is-slut), går att välja, köp låst
   — kombinationen finns inte (is-saknas): klick hoppar till närmaste
     variant som har värdet.
   Utan JS fungerar länken som vanligt (produktsidan öppnas).
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var FARG = /f[äa]rg|colou?r|modell/i;
  var STORLEK = /storlek|size/i;
  var PACK = /f[öo]rpackning|antal|kvantitet|pack/i;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
  var fmt = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(cents) { return fmt.format(cents / 100); }

  var sheet, panel, els, lastFocus, product, order, sel, cache = {}, scrollY0 = 0;

  /* Skrollstängning utan att positionen nollas: body låses fixerad på samma höjd
     och skrollas tillbaka när arket stängs. (overflow:hidden på html hoppade till toppen.) */
  function lockScroll() { scrollY0 = window.scrollY || window.pageYOffset || 0; document.body.style.position = "fixed"; document.body.style.top = (-scrollY0) + "px"; document.body.style.left = "0"; document.body.style.right = "0"; document.body.style.width = "100%"; }
  function unlockScroll() { document.body.style.position = ""; document.body.style.top = ""; document.body.style.left = ""; document.body.style.right = ""; document.body.style.width = ""; window.scrollTo(0, scrollY0); }
  var TXT = {
    atc: 'Lägg i varukorgen',
    adding: 'Lägger i varukorgen…',
    added: 'Tillagd i varukorgen',
    slut: 'Slutsåld',
    saknas: 'Finns inte i den kombinationen',
    fel: 'Det gick inte att lägga varan i varukorgen. Prova igen eller öppna produktsidan.',
    lank: 'Visa hela produkten',
    valj: 'Välj'
  };

  function build() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'nr-sv';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="nr-sv__overlay" data-nr-sv-close></div>' +
      '<div class="nr-sv__panel" role="dialog" aria-modal="true" aria-labelledby="nr-sv-titel" tabindex="-1">' +
        '<button type="button" class="nr-sv__close" data-nr-sv-close aria-label="Stäng">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="nr-sv__head">' +
          '<div class="nr-sv__img" data-nr-sv-img></div>' +
          '<div class="nr-sv__headtext">' +
            '<p class="nr-sv__marke" data-nr-sv-marke></p>' +
            '<h2 class="nr-sv__titel" id="nr-sv-titel" data-nr-sv-titel></h2>' +
            '<p class="nr-sv__pris"><span data-nr-sv-pris></span></p>' +
          '</div>' +
        '</div>' +
        '<div class="nr-sv__body" data-nr-sv-options></div>' +
        '<p class="nr-sv__msg" data-nr-sv-msg role="status" aria-live="polite" hidden></p>' +
        '<div class="nr-sv__foot">' +
          '<button type="button" class="nr-btn nr-btn--stor nr-btn--full" data-nr-sv-atc>' + TXT.atc + '</button>' +
          '<a class="nr-sv__lank" data-nr-sv-lank href="#">' + TXT.lank + '</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.nr-sv__panel');
    els = {
      img: sheet.querySelector('[data-nr-sv-img]'),
      marke: sheet.querySelector('[data-nr-sv-marke]'),
      titel: sheet.querySelector('[data-nr-sv-titel]'),
      pris: sheet.querySelector('[data-nr-sv-pris]'),
      options: sheet.querySelector('[data-nr-sv-options]'),
      msg: sheet.querySelector('[data-nr-sv-msg]'),
      atc: sheet.querySelector('[data-nr-sv-atc]'),
      lank: sheet.querySelector('[data-nr-sv-lank]')
    };
    sheet.querySelectorAll('[data-nr-sv-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (sheet.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') trapFocus(e);
    });
    els.atc.addEventListener('click', addToCart);
    els.options.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nr-sv-val]');
      if (!b) return;
      choose(parseInt(b.dataset.opt, 10), b.dataset.nrSvVal);
    });
  }

  function trapFocus(e) {
    var f = panel.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(handle, url, trigger) {
    build();
    lastFocus = trigger;
    els.lank.href = url;
    els.msg.hidden = true;
    els.options.innerHTML = '<p class="nr-sv__laddar">Hämtar varianter…</p>';
    els.titel.textContent = trigger.getAttribute('aria-label') ? trigger.getAttribute('aria-label').split(', ').slice(1).join(', ') : '';
    els.marke.textContent = '';
    els.pris.textContent = '';
    setFore(null);
    els.img.innerHTML = '';
    els.atc.disabled = true;
    els.atc.textContent = TXT.atc;
    sheet.hidden = false;
    lockScroll();
    panel.focus({ preventScroll: true });
    load(handle).then(function (p) {
      product = p;
      /* /products/<handle>.js ger options antingen som strängar eller som objekt {name, position, values}. */
      product.optionNames = p.options.map(function (o) { return typeof o === "string" ? o : o.name; });
      product.optionValues = p.options.map(function (o, i) { if (o && o.values) return o.values.slice(); var vals = []; p.variants.forEach(function (x) { if (vals.indexOf(x.options[i]) < 0) vals.push(x.options[i]); }); return vals; });
      order = optionOrder(product.optionNames);
      var start = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      sel = start.options.slice();
      renderHead();
      render();
    }).catch(function () {
      els.options.innerHTML = '';
      msg(TXT.fel);
    });
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function optionOrder(names) {
    var first = [], mid = [], size = [], pack = [];
    names.forEach(function (n, i) {
      if (FARG.test(n)) first.push(i); else if (STORLEK.test(n)) size.push(i); else if (PACK.test(n)) pack.push(i); else mid.push(i);
    });
    return first.concat(mid, size, pack);
  }

  function findVariant(opts) {
    return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
  }

  /* Läge för ett värde givet de ANDRA valen. */
  function stateFor(i, val) {
    var cands = product.variants.filter(function (v) {
      if (v.options[i] !== val) return false;
      return v.options.every(function (o, j) { return j === i || sel[j] == null || o === sel[j]; });
    });
    if (!cands.length) return 'saknas';
    return cands.some(function (v) { return v.available; }) ? 'ok' : 'slut';
  }

  function choose(i, val) {
    sel[i] = val;
    if (!findVariant(sel)) {
      /* Närmaste variant som har värdet: helst i lager, sedan flest träffar mot övriga val. */
      var best = null, bestScore = -1;
      product.variants.forEach(function (v) {
        if (v.options[i] !== val) return;
        var score = (v.available ? 100 : 0) + v.options.reduce(function (n, o, j) { return n + (j !== i && o === sel[j] ? 1 : 0); }, 0);
        if (score > bestScore) { bestScore = score; best = v; }
      });
      if (best) sel = best.options.slice();
    }
    render();
  }

  /* Jämförpriset finns bara i DOM när varianten är nedsatt: inget tomt <s>. */
  function setFore(cents) {
    var fore = els.pris.parentElement.querySelector('[data-nr-sv-fore]');
    if (cents) {
      if (!fore) { fore = document.createElement('s'); fore.setAttribute('data-nr-sv-fore', ''); els.pris.parentElement.appendChild(document.createTextNode(' ')); els.pris.parentElement.appendChild(fore); }
      fore.textContent = money(cents);
    } else if (fore) { fore.remove(); }
  }

  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function renderHead() {
    els.marke.textContent = product.vendor || '';
    els.titel.textContent = product.title;
  }

  function render() {
    var v = findVariant(sel);
    var html = '';
    order.forEach(function (i) {
      var name = product.optionNames[i];
      var values = product.optionValues[i];
      var arFarg = FARG.test(name);
      var typ = arFarg ? 'farg' : (STORLEK.test(name) ? 'storlek' : 'annat');
      /* Färg/modell = chips eller bildkort, storlek = kompakta textknappar (stil i nr-v2.css). */
      html += '<fieldset class="nr-sv__grupp nr-sv__grupp--' + typ + '"><legend>' + esc(name) + ': <span>' + esc(sel[i] || '') + '</span></legend><div class="nr-sv__valrad">';
      /* Första alternativet (färg/modell) är alltid valbart och hoppar till närmaste variant; övriga stängs av när de inte går att köpa. */
      var hoppar = order.length > 1 && i === order[0];
      values.forEach(function (val) {
        var st = stateFor(i, val);
        var bild = null;
        if (arFarg) { var vb = product.variants.find(function (x) { return x.options[i] === val && x.featured_image && x.featured_image.src; }); if (vb) bild = vb.featured_image.src; }
        var cls = 'nr-sv__val nr-sv__val--' + typ + (bild ? ' nr-sv__val--bild' : '') + (sel[i] === val ? ' is-vald' : '') + (st === 'slut' ? ' is-slut' : '') + (st === 'saknas' ? ' is-saknas' : '');
        var extra = st === 'slut' ? ' title="' + TXT.slut + '"' : (st === 'saknas' ? ' title="' + TXT.saknas + '"' : '');
        if (!hoppar && st !== 'ok') extra += ' disabled';
        var inner = bild ? '<img src="' + imgUrl(bild, 160) + '" alt="" loading="lazy"><span>' + esc(val) + '</span>' : esc(val);
        html += '<button type="button" class="' + cls + '" data-nr-sv-val="' + esc(val) + '" data-opt="' + i + '" aria-pressed="' + (sel[i] === val) + '"' + extra + '>' + inner + '</button>';
      });
      html += '</div></fieldset>';
    });
    els.options.innerHTML = html;

    var img = (v && v.featured_image && v.featured_image.src) || (product.featured_image) || '';
    els.img.innerHTML = img ? '<img src="' + imgUrl(img, 320) + '" alt="" width="96" height="96" loading="lazy">' : '';

    if (v) {
      /* Kombinationstemat 2026-09-26: jämförpriset visas bara när temainställningen ha_show_compare är på (window.NR_VISA_JAMFOR, satt i layout/theme.liquid). */
      /* 2026-09-28: paket (typen Paket eller taggen paket) visar aldrig jämförpris eller rabatt – samma regel som ha-price. */
      var arPaket = product.type === 'Paket' || (product.tags || []).indexOf('paket') > -1;
      var onSale = !arPaket && window.NR_VISA_JAMFOR === true && v.compare_at_price && v.compare_at_price > v.price;
      /* Välkomstrabatten: 10 % över 400 kr, samma regel som korten (snippets/nr-pris). Riktigt jämförpris går före.
         window.NR_KAMPANJ sätts i snippets/nr-tweaks2 från snippets/nr-kampanj (slutdatumet står bara där). */
      var kampanj = !arPaket && !onSale && window.NR_KAMPANJ === true && v.price > 40000;
      els.pris.textContent = money(kampanj ? Math.round(v.price * 0.9) : v.price);
      setFore(onSale ? v.compare_at_price : (kampanj ? v.price : null));
      els.atc.disabled = !v.available;
      els.atc.textContent = v.available ? TXT.atc : TXT.slut;
      els.pris.parentElement.classList.toggle('nr-pris--rabatt', !!(onSale || kampanj));
    } else {
      els.pris.textContent = money(product.price);
      setFore(null);
      els.atc.disabled = true;
      els.atc.textContent = TXT.saknas;
    }
    els.msg.hidden = true;
  }

  function msg(text) { els.msg.textContent = text; els.msg.hidden = false; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function addToCart() {
    var v = findVariant(sel);
    if (!v || !v.available) return;
    els.atc.disabled = true;
    els.atc.textContent = TXT.adding;
    var done = function () {
      els.atc.textContent = TXT.added;
      setTimeout(function () { close(); els.atc.disabled = false; els.atc.textContent = TXT.atc; }, 500);
    };
    var fail = function (text) {
      els.atc.disabled = false;
      els.atc.textContent = TXT.atc;
      msg(text || TXT.fel);
    };
    if (typeof window.nrKombiLaggTill === 'function') {
      /* Kombinationstemat 2026-09-26: nya temats varukorgslåda (assets/nr-kombi.js). */
      window.nrKombiLaggTill(v.id, 1).then(done).catch(function (e) { fail(e && e.message); });
    } else if (window.jQuery && window.theme && window.theme.ajaxCart && typeof window.theme.ajaxCart.update === 'function') {
      /* Samma väg som Debutifys egna köpknappar: jQuery → ajaxComplete (räknaren) + lådan. */
      window.jQuery.ajax({
        type: 'POST', url: '/cart/add.js', data: { id: v.id, quantity: 1 }, dataType: 'json',
        success: function () { try { window.theme.ajaxCart.update(); } catch (e) {} done(); },
        error: function (xhr) { fail(xhr && xhr.responseJSON && xhr.responseJSON.description); }
      });
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || ''); }); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (e) { fail(e.message); });
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nr-snabbval]');
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    open(a.dataset.nrSnabbval, a.getAttribute('href'), a);
  });
})();